'use strict';
import get from 'lodash/get';
import {createEventHandler} from 'recompose';
import fuse from '../../../_libs/redux-fusion/index';
import {getItemFromState} from '../../../_libs/redux-observable-list';
import {animatedStateGo} from '../../../app/actions';
import {ViewSwitcherDirection} from '../../../app/enums';
import {getProjectReduxItem} from '../../../app/model/reducers/state';
import {buildBreadcrumbPath$} from '../../../app/navigation/utils/index';
import {getId} from '../../../core-utilities/domain/ReduxUtils';
import {
  buildFilterData$,
  ReduxListFilterStreamedContainer,
  ReduxListStreamedContainer,
} from '../../../core-utilities/redux/ReduxListContainer';
import {TaskType} from '../../../tasks/enums/TaskType';
import {componentOptions, reduxList} from '../../../tasks/redux/templateTasks';
import {updateMilestoneIdFilter} from '../../../tasks/redux/utils';
import {templateTasksStates} from '../../../tasks/router-config';
import {ProjectViewTemplateView} from './ProjectViewTemplateView';


const StreamedComponent = (state$, dispatch) => (props$) => {
  const taskType = TaskType.TEMPLATE;

  /** @type {ReduxObservableListActions} */
  const actions = reduxList.actions;
  /** @type {ReduxObservableListOptions} */
  const reduxListOptions = reduxList.options;

  // need actions for milestone toggles
  const {
    handler: onToggleMilestoneVisibility,
    stream: toggleMilestoneVisibility$,
  } = createEventHandler();

  const onClickVisibilityButton = (e, model) => onToggleMilestoneVisibility(getId(model));
  const onClickVisibilityToggleAllButton = () => onToggleMilestoneVisibility('all');
  const onTaskClick = (e, model) => dispatch(animatedStateGo({
    state: templateTasksStates.requirements,
    params: {taskId: getId(model)},
    direction: ViewSwitcherDirection.forward,
  }));

  const filterData$ = buildFilterData$(state$, reduxListOptions);

  const projectItem$ = state$
    .map(getProjectReduxItem)
    .distinctUntilChanged();

  const isVisibilityAllCollapsed$ = filterData$
    .map(filterData => get(filterData.filterOptions, 'milestone.id.all', false))
    .distinctUntilChanged();

  toggleMilestoneVisibility$
    .withLatestFrom(projectItem$, filterData$)
    .takeUntil(props$.last())
    .subscribe(([id, projectItem, filterData]) => {
      const filterOptions = updateMilestoneIdFilter(id, filterData);
      dispatch(actions.applyFilter({...filterData, filterOptions}, {parentId: projectItem.id}));
    });

  const breadcrumbPath$ = buildBreadcrumbPath$({state$, taskType});

  return props$
    .combineLatest(
      breadcrumbPath$,
      projectItem$,
      isVisibilityAllCollapsed$,
      (props, breadcrumbPath, projectItem, isVisibilityAllCollapsed) => ({
        ...props,
        taskType,
        breadcrumbPath,
        project: getItemFromState(projectItem),
        parentId: projectItem.id,
        init: projectItem.init,
        modelMode: projectItem.mode,
        isVisibilityAllCollapsed,

        onTaskClick,
        onClickVisibilityButton,
        onClickVisibilityToggleAllButton,
      }));
};

const ListComponent = ReduxListStreamedContainer(
  ProjectViewTemplateView,
  reduxList,
  componentOptions,
);
export const FilteredListComponent = ReduxListFilterStreamedContainer(ListComponent, reduxList, componentOptions);
export const ProjectViewTemplateContainer = fuse(StreamedComponent)(FilteredListComponent);



// WEBPACK FOOTER //
// ./src/js/projects/components/ProjectViewTemplate/ProjectViewTemplateContainer.js